{
  "progress": {
    "actions": {
      "remove": "supprimer le progrès de l'objectif",
      "edit": "Modifier",
      "delete": "Supprimer"
    },
    "confirmation": {
      "remove_title": "Supprimer le progrès",
      "remove_content": "Êtes-vous sûr de vouloir supprimer ce progrès ?"
    },
    "form": {
      "create_button": "Créer un progrès",
      "update_button": "Mettre à jour le progrès",
      "target_description": "Votre objectif est",
      "current_value": "La valeur actuelle est",
      "comment_label": "Commentaire",
      "checkin_date_label": "Date de vérification"
    },
    "status": {
      "updated_value": "a mis à jour la valeur à {{value}}"
    }
  },
  "form": {
    "create_title": "Créer un objectif",
    "update_title": "Mettre à jour l'objectif",
    "objective_label": "Objectif",
    "objective_placeholder": "Objectif",
    "description_label": "Description",
    "description_placeholder": "Description",
    "owners_label": "Propriétaires",
    "owners_placeholder": "Propriétaires",
    "target_date_label": "Date cible",
    "target_date_placeholder": "Date cible"
  },
  "measure": {
    "title": "Mesure",
    "unit_label": "Unité",
    "custom_unit_placeholder": "Spécifiez votre unité personnalisée ici",
    "preview_label": "Aperçu :",
    "target_label": "Cible",
    "target_placeholder": "Valeur cible",
    "initial_label": "Initial",
    "initial_placeholder": "Valeur initiale",
    "new_amount_placeholder": "Veuillez saisir le nouveau montant",
    "client_unit": "Client"
  },
  "validation": {
    "title_required": "Veuillez ajouter un titre pour l'objectif",
    "title_max_length": "Doit contenir moins de 160 caractères",
    "target_date_required": "Veuillez saisir une date cible",
    "owners_required": "Veuillez ajouter au moins un propriétaire",
    "target_value_required": "Veuillez ajouter une cible",
    "target_value_positive": "Veuillez saisir un montant positif",
    "initial_value_positive": "Veuillez saisir un montant positif",
    "measure_value_required": "Veuillez saisir le nouveau montant",
    "measure_value_positive": "Veuillez saisir un montant positif",
    "checkin_date_required": "Veuillez saisir une date de vérification"
  },
  "actions": {
    "edit": "Modifier",
    "archive": "Archiver",
    "unarchive": "Désarchiver",
    "delete": "Supprimer l'objectif",
    "create": "Créer un objectif",
    "link_workspace": "Lier à l'espace de travail",
    "unlink_workspace": "délier le projet"
  },
  "labels": {
    "description": "Description",
    "owners": "Propriétaires",
    "measure": "Mesure",
    "progress": "Progrès",
    "workspaces": "Espaces de travail",
    "current": "Actuel",
    "target": "Cible",
    "target_date": "Date cible",
    "status": "Statut",
    "group_by": "Grouper par",
    "filter": "Filtrer",
    "workspace": "espace de travail"
  },
  "status": {
    "active": "Actif",
    "archived": "Archivé"
  },
  "messages": {
    "stay_focused": "Restez concentré sur ce qui compte et atteignez nos objectifs.",
    "use_tracker": "Utilisez le suivi d'objectifs de NEXL pour définir vos objectifs commerciaux trimestriels ou annuels. Fixez des objectifs de revenus, des objectifs de développement commercial ou même des objectifs personnels. Avec le suivi d'objectifs, il est facile de rester concentré et de suivre vos progrès.",
    "link_workspace_validation": "Veuillez sélectionner un projet"
  },
  "confirmations": {
    "archive_title": "Archiver l'objectif",
    "archive_content": "Êtes-vous sûr de vouloir archiver cet objectif ?",
    "unarchive_title": "Désarchiver l'objectif",
    "unarchive_content": "Êtes-vous sûr de vouloir désarchiver cet objectif ?",
    "delete_title": "Supprimer l'objectif",
    "delete_content": "Êtes-vous sûr de vouloir supprimer cet objectif ? Toutes les données seront supprimées et ne pourront pas être récupérées.",
    "unlink_workspace_title": "Êtes-vous sûr de vouloir délier cet espace de travail ?",
    "unlink_workspace_content": "Vous pouvez toujours le rajouter plus tard."
  },
  "aria_labels": {
    "objective_actions": "Actions d'objectif",
    "link_workspace": "lier l'espace de travail",
    "create_objective_progress": "créer le progrès de l'objectif",
    "show_filters": "afficher les filtres",
    "filters_active": "les filtres {{status}} sont actifs"
  },
  "filters": {
    "clear_filters": "Effacer les filtres"
  }
}
